import React from 'react';
import { useTranslation } from 'react-i18next';

import { Grid } from '@mui/material';
import { FOR_BANK_SECTIONS, FOR_BANK_SUB_SECTIONS } from 'constants/businessToolSections/forBank';

import useCheckSubSectionAccess from 'hooks/useCheckSubSectionAccess';

import { FormSectionCard } from 'components/_basic/FormSectionCard';
import { FormSectionFilledCard } from 'components/_basic/FormSectionFilledCard';

import { concatWithDot } from 'helpers/string';

import { ExpensesInfoRow } from './components';
import { MONTHLY_EXPENSES_FORM_CHUNKS, MONTHLY_EXPENSES_FORM_NAMES } from './utils/form';
import { monthlyExpensesPrefix } from '../utils/form';

export const MonthlyExpensesForm: React.FC = () => {
  const { t } = useTranslation();

  const canAccess = useCheckSubSectionAccess(
    FOR_BANK_SECTIONS.FINANCIAL_PLAN,
    FOR_BANK_SUB_SECTIONS.FOR_BANK_FINANCIAL_PLAN.PLANNED_EXPENSES,
  );

  const monthlyExpensesFormWithoutNonOperatingExpanses = Object.values(MONTHLY_EXPENSES_FORM_CHUNKS).slice(0, -1)

  return (
    <FormSectionCard
      collapsible
      title={t('financialPlan.plannedExpenses.monthlyExpenses.title')}
      disabled={!canAccess}
      aiFieldName={monthlyExpensesPrefix}
      aiFieldType="complex"
    >
      <Grid container spacing={3}>
        {monthlyExpensesFormWithoutNonOperatingExpanses.map((chunk) => (
          <Grid item xs={12} key={chunk}>
            <FormSectionFilledCard title={t(`financialPlan.plannedExpenses.monthlyExpenses.${chunk}`)}>
              <ExpensesInfoRow
                expensesName={concatWithDot(monthlyExpensesPrefix, MONTHLY_EXPENSES_FORM_NAMES[chunk].EXPENSES)}
                revenueName={concatWithDot(monthlyExpensesPrefix, MONTHLY_EXPENSES_FORM_NAMES[chunk].REVENUE)}
                growthRateName={concatWithDot(monthlyExpensesPrefix, MONTHLY_EXPENSES_FORM_NAMES[chunk].GROWTH_RATE)}
                disabled={!canAccess}
                watchTableName={concatWithDot(MONTHLY_EXPENSES_FORM_NAMES[chunk].TABLE_NAME)}
              />
            </FormSectionFilledCard>
          </Grid>
        ))}
      </Grid>
    </FormSectionCard>
  );
};
